/* eslint-disable no-unused-expressions */
/* eslint-disable require-jsdoc */
import React, {useEffect, useState} from 'react';
import Slider from 'react-slick';
import Tile from './eventTile.jsx';
import carouselSettings from './carouselSettings';
import http from '../services/http.js';
import {hasProp, isValid} from '../utils/validate';
import MainFilterPanel from './filters/MainFilterPanel';
import {todaysDate, futureDates} from '../utils/date';
import {dayChoiceForDb, genreChoiceForDb, searchChoiceForDb, sortChoiceForDb}
  from './filters/filterChoiceForDb';
import PopUp from './popUp/popUp';
import Event from './popUp/Event';
import Bands from './popUp/Bands';
import Venue from './popUp/Venue';
import PopUpMap from './popUp/map/Map';
import PropTypes from 'prop-types';
import { pApiBase, subscriber } from '../../../config.js';
import CarouselHeader from './CarouselHeader.js';
import genreObjIntoStrConvert from '../utils/genreObjIntoStrConvert.js';
import _ from "lodash";
import { debug } from '../config.js';
import RingLoader from 'react-spinners/RingLoader';

export default function SimpleSlider(props) {
  const [windowWidth, setWindowWidth] = useState('');
  const [showHowManySlides, setShowHowManySlides] = useState(5);

  const [events, setEvents] = useState([]);
  const [changeInFilter, setChangeInFilter] = useState(false);

  const [eventGuidForPopUp, setEventGuidForPopUp] = useState('');
  const [popUpOnMouseUpCoord, setPopUpOnMouseUpCoord] = useState([]);
  const [popUpOnMouseDownCoord, setPopUpOnMouseDownCoord] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);

  const [popUpData, setPopUpData] = useState([]);
  const [popUpDataObj, setPopUpDataObj] = useState({});

  const [next, setNext] = useState(false);

  const [chosenGenre, setChosenGenre] = useState('');
  const [chosenDay, setChosenDay] = useState('month');
  const [powerSearchCarouselData, setPowerSearchCarouselData] = useState('');

  let defaultSorting=isValid(Object.values(props.sharedEventParams)[0]) && !isValid(powerSearchCarouselData) ?
    'distance' : 'date';
  const [chosenSort, setChosenSort] = useState(defaultSorting);
  const [chosenSearch, setChosenSearch] = useState('');

  const [carouselLoaded, setCarouselLoaded] = useState(true);

  const [lat, setLat] = useState(props.mainCarouselConfigObj.lat);
  const [lon, setLon] = useState(props.mainCarouselConfigObj.lon);
  const [load, setLoad] = useState(true);
  const [location, setLocation] = useState({lat: props.mainCarouselConfigObj.lat, lon: props.mainCarouselConfigObj.lon});
  // let firstCall = useRef(true);

  const [userConfigTimeFrame, setUserConfigTimeFrame] = useState('');

  const [eventGuidLink,] = useState(Object.values(props.sharedEventParams)[0]);
  
  const [imagePathForEventImgLink, setImagePathForEventImgLink] = useState('');

  useEffect(() => {
    if (!isValid(powerSearchCarouselData) && isValid(Object.values(props.sharedEventParams)[0])) {
      setChosenSort('distance');
    }
    else {
      setChosenSort('date');
    }
  }, [powerSearchCarouselData, Object.values(props.sharedEventParams)[0]]);
  
  // useState hook that will be set by map marker click and passed venueGuid
  // const [venueGuid, setVenueGuid] = useState('');

  if (props.mainCarouselConfigObj.usePowersearch === true) {
    window.changePowersearchLoc = function (newLat, newLon) {
      const newLoc = {
        lat: newLat,
        lon: newLon
      }
      _.isEqual(location, newLoc) ? null : setLocation(newLoc);
    };
    
    window.changeReactCarouselData = function (lat, lon, minDate, 
      maxDate, searchVal, genre, distance) {
      // console.log('changeReactCarouselData', lat, lon, minDate, 
        // maxDate, searchVal, genre, distance);
      const powerSearchPartOfQuery = lat + lon + minDate
      + maxDate + searchVal + `&genre=`+genreObjIntoStrConvert(JSON.parse(genre))
      + distance;
      // console.log('powerSearchPartOfQuery: ', powerSearchPartOfQuery);
      setPowerSearchCarouselData(powerSearchPartOfQuery);
    }
  }
  const dbDataRequest = async (newOffset) => {
    const genreChoice=genreChoiceForDb(chosenGenre);
    const sortChoice=sortChoiceForDb(chosenSort);

    const dayChoice=isValid(props.mainCarouselConfigObj.minDate) && isValid(props.mainCarouselConfigObj.maxDate)
       && isValid(props.mainCarouselConfigObj.timeframe) ?
       dayChoiceForDb(props.mainCarouselConfigObj.timeframe, todaysDate, futureDates)
      : dayChoiceForDb(chosenDay, todaysDate, futureDates);

    const searchChoice=searchChoiceForDb(chosenSearch);

    const offset = newOffset ? newOffset : 0;  
    
    const subscriberStr = isValid(subscriber) ? 
    `&subscriber=${subscriber}`: ``;
    
    const eventType = isValid(props.mainCarouselConfigObj.eventType) ?
      `&event_type=${props.mainCarouselConfigObj.eventType}` :
      ``;

    // console.log('carousel.jsx Object.values(props.sharedEventParams)[0]: ', Object.values(props.sharedEventParams)[0]);
    
    let query='';
    if (isValid(eventGuidLink) && !isValid(powerSearchCarouselData)) { //still must change evenGuidLink to pObject.values(props.sharedEventParams)[1] !!!
      query = `${pApiBase}/carousel?lat=${Object.values(props.sharedEventParams)[1]}`+
      `&lon=${Object.values(props.sharedEventParams)[2]}&distance=${props.mainCarouselConfigObj.distance}&`+
      `${sortChoice}&offset=${offset}${searchChoice}`+
      `&limit=20${genreChoice}`+`&${dayChoice}`+ subscriberStr + eventType;
    } else {
      query = isValid(powerSearchCarouselData) ?
      `${pApiBase}/carousel?`+ powerSearchCarouselData +
      `&${sortChoice}&offset=${offset}${searchChoice}&limit=20`+
        subscriberStr + eventType:
      `${pApiBase}/carousel?lat=${location.lat}`+
      `&lon=${location.lon}&distance=${props.mainCarouselConfigObj.distance}&`+
      `${sortChoice}&offset=${offset}${searchChoice}`+
      `&limit=20${genreChoice}`+`&${dayChoice}`+ subscriberStr + eventType;
    }

    //console.log('offset is ', newOffset);
    //console.log('query is ', query);
    // console.log('carousel.js searchChoice', searchChoice);
    // console.log('carousel.js query', query);

    const response = await http.get(
        props.mainCarouselConfigObj.hearbyApiKey,
        query,
        true,
    );
    // console.log('response in dbDataRequest', response);
    // console.log('query in dbDataRequest', String(query));
    // console.log('next page? ', hasProp(response._links, 'next'));

    hasProp(response._links, 'next') ? setNext(true) : setNext(false);
    setLoad(false);
    return response;
  };

  const dbPopUpDataRequest = async () => {
    const query=isValid(props.mainCarouselConfigObj.eventGuid) &&
     !isValid(eventGuidForPopUp) ?
    `${pApiBase}/event-detail?event_guid=${props.mainCarouselConfigObj.eventGuid}` :
    `${pApiBase}/event-detail?event_guid=${eventGuidForPopUp}`;

    const response = (eventGuidForPopUp || props.mainCarouselConfigObj.eventGuid) ?
     await http.get(
         props.mainCarouselConfigObj.hearbyApiKey,
         query,
         true,
     ) : '';

    // console.log('dbPopUpDataRequest query', query);
    // console.log('eventGuidForPopUp in dbPopUpDateReq', eventGuidForPopUp);
    // console.log('dbPopUpDataRequest before setPopUp', response.results[0]);
    response ? setPopUpDataObj(response.results[0]) : null;
  };


  const getPopUpEvents = async () => {
    const popUpResponse = await dbPopUpDataRequest();
    // console.log('popUp response', popUpResponse);
    setPopUpData(popUpResponse);
    return popUpData;
  };

  const getEvents = async (newOffset) => {
    try {
      const genreChoice=genreChoiceForDb(chosenGenre);
      const sortChoice=sortChoiceForDb(chosenSort);
     // setCarouselLoaded(false);
      // console.log('genreChoiceForDb in getEvents', genreChoice);
      const currentResponse = newOffset ? await dbDataRequest(newOffset):
      await dbDataRequest();
      // if (currentResponse.results) {
      //   firstCall = false
      // }
      const initialCarouselSettings =
       (genreChoice!=='' || sortChoice!=='date') && !newOffset;

      const respArray=initialCarouselSettings ? currentResponse.results :
      events.concat(currentResponse.results);
      // console.log('respArray: ', respArray);
      setEvents(respArray);
    //  events.length === 0 ? setCarouselLoaded(true) : setCarouselLoaded(false);
      // if (events === []){
      //   setCarouselLoaded(true);
      // }
     // setCarouselLoaded(true);
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    getEvents();
    setChangeInFilter(true);
  }, [chosenGenre, chosenSort, chosenDay, 
      chosenSearch, powerSearchCarouselData, 
      location, userConfigTimeFrame, eventGuidLink]);

  useEffect(() => {
    getPopUpEvents();
  }, [eventGuidForPopUp]);

  const slideNumViaWinSize = () => {
    const winWidth= window.innerWidth;  
    setWindowWidth(winWidth);

    if (props.mainCarouselConfigObj.numSlides===5) {
      if(windowWidth<=766) {
        setShowHowManySlides(2);
      }
      else if(windowWidth>766 && windowWidth<=992) {
        setShowHowManySlides(4);
      }
      else if(windowWidth>992) {
        setShowHowManySlides(5);
      }
    } else if (props.mainCarouselConfigObj.numSlides===4) {
      if(windowWidth<=766) {
        setShowHowManySlides(2);
      }
      else if(windowWidth>766) {
        setShowHowManySlides(4);
      }
    } else if (props.mainCarouselConfigObj.numSlides===2) {
      if (isValid(windowWidth)){
        setShowHowManySlides(2);
      }
    }

    // console.log('window size in resizeEvent', windowWidth);
    if (windowWidth<=766 && !isValid(props.mainCarouselConfigObj.numSlides)) {
      setShowHowManySlides(2);
    } else if (windowWidth>766 && windowWidth<=992 &&
      !isValid(props.mainCarouselConfigObj.numSlides)) {
      setShowHowManySlides(4);
    } else if (windowWidth>992 && !isValid(props.mainCarouselConfigObj.numSlides)) {
      setShowHowManySlides(5);
    }
    
  };

  useEffect(() => {
    props.mainCarouselConfigObj.genre ?
      setChosenGenre(props.mainCarouselConfigObj.genre) : null;
    props.mainCarouselConfigObj.sort ?
      setChosenSort(props.mainCarouselConfigObj.sort) : null;

      isValid(props.mainCarouselConfigObj.eventGuid) && setModalOpen(true)?
       setEventGuidForPopUp(props.mainCarouselConfigObj.eventGuid) :
       null;
  }, []);

  useEffect(() => {
    window.addEventListener('resize', slideNumViaWinSize); 
    slideNumViaWinSize();
    
    return function cleanup() {
      window.removeEventListener('resize', slideNumViaWinSize);
    }
  });


  const settings = carouselSettings(events, next, getEvents, showHowManySlides);

  useEffect(() => {
    const carouselElement = document.querySelector('[dir="ltr"]');
    // console.log('element', carouselElement);
    if (isValid(carouselElement) && events.length > 0) {
      setCarouselLoaded(true);
    } else if (isValid(carouselElement)&& events.length===0){
      setCarouselLoaded(false);
    }
  });  

  const handleUserGenreInputChange = (result) => {
    setChosenGenre(result);
  };

  const handleUserSortInputChange = (result) => {
    setChosenSort(result);
  };

  const handleUserDayInputChange = (result) => {
    setChosenDay(result);
    debug && console.log('day result in carousel.js',result);
  };

  const handleUserSearchInputChange = (result) => {
    setChosenSearch(result);
  };

  const handleModalChange = (newValue) => {
    setModalOpen(newValue);
  };

  const handleEventGuidForPopUp = (newValue) => {
    setEventGuidForPopUp(newValue);
  };

  const handleClickValidationForPopUp = (onMouseUp, onMouseDown) => {
    setPopUpOnMouseUpCoord(() => [{
      xValue: onMouseUp[0],
      yValue: onMouseUp[1],
    }]);

    setPopUpOnMouseDownCoord(() => [{
      xValue: onMouseDown[0],
      yValue: onMouseDown[1],
    }]);
    // console.log('popUpOnMouseUpCoord', popUpOnMouseUpCoord);
    // console.log('popUpOnMouseDownCoord', popUpOnMouseDownCoord);
  };

  const refFunc = (element) => {
    // console.log('refFunc ChosenDay in refFunc: '+chosenDay);
    // console.log('refFunc changeInFilter: '+changeInFilter);
    // console.log('refFunc element: '+element);

    if (element) {
      if ((changeInFilter===true) ) {
        element.slickGoTo(0);
        setChangeInFilter(false);
        // console.log('refFunc changeInFilter if loop: '+changeInFilter);
        // console.log('element', element.slickGoTo(0));
      }
    }
  };

  const recallingDefaultImage = () => {
    const guid = eventGuidForPopUp ? eventGuidForPopUp : '';

    const tempElement = guid ?
     document.querySelector(`a[event-id="${guid}"]`) : '';

    const element = tempElement ?
    tempElement.outerHTML.split('default-img=')[1]
        .split('class')[0].replace('"', '') :
    'None';
    setImagePathForEventImgLink(element);
    return element;
  };

  useEffect(() => {
    // console.log('carousel.js eventGuidLink: ', eventGuidLink);
    isValid(eventGuidLink) && openSharedModal();
  }, [eventGuidLink]);

  const openSharedModal = () => {
    setEventGuidForPopUp(eventGuidLink);
    setModalOpen(true);
    return modalOpen;
  }

  return (
    <div>
      {/* {console.log('powerSearchCarouselData: ', powerSearchCarouselData)}  */}

      <div className="hearby-carousel-header">
        <CarouselHeader title={props.mainCarouselConfigObj.title} />
        <MainFilterPanel
        chosenGenre = {chosenGenre}
        chosenSort = {chosenSort}
        chosenDay = {chosenDay}
        menuOpts = {props.mainCarouselConfigObj.menuOpts}
        defaultGenreValue={props.mainCarouselConfigObj.genre}
        defaultSortValue={chosenSort}
        defaultDayValue=
          {props.mainCarouselConfigObj.maxDate}
        onUserGenreInputChange={handleUserGenreInputChange}
        onUserSortInputChange={handleUserSortInputChange}
        onUserDayInputChange={handleUserDayInputChange}
        onUserSearchInputChange={handleUserSearchInputChange}
      />
      </div>
      {!carouselLoaded ?
        <div className ='hearby-no-search-results'>
          <span className='hearby-no-search-results-text'>No shows found</span>
        </div> : null}
      <Slider {...settings} ref={refFunc}>
        {events.map((event) => (
          <Tile className='tileclass'
            eventType={props.mainCarouselConfigObj.eventType}
            key={event.event.eventGuid}
            results={event}
            chosenSlide = {eventGuidForPopUp}
            onSlideChoiceChange={handleEventGuidForPopUp}
            clickValidation={handleClickValidationForPopUp}
            eventImage={event? event.event.eventImage: null}
            // eventImage={event? event.event.eventImage: (eventGuidLink ? imagePathForEventImgLink:null)}
            clicked={() => {
              if (popUpOnMouseDownCoord) {
                if (Math.abs(popUpOnMouseDownCoord[0].xValue -
                  popUpOnMouseUpCoord[0].xValue) < 5 &&
                  Math.abs(popUpOnMouseDownCoord[0].yValue -
                  popUpOnMouseUpCoord[0].yValue) < 5) {
                  setModalOpen(true);
                  return "clicked"
                } else return "not clicked"
              }
            }}
          >
            {/* {console.log('carousel eventImage', event.event.eventImage)} */}
          </Tile>
        ))}
      </Slider>
      <PopUp
        openOrNot={modalOpen}
        onChange={handleModalChange}
        theme={props.mainCarouselConfigObj.theme}
      >
        { popUpDataObj!== undefined && hasProp(popUpDataObj, 'venue') ? <div>
          <Event
            hearbyKey={props.mainCarouselConfigObj.hearbyApiKey}
            event={popUpDataObj.event}
            venue={popUpDataObj.venue}
            defaultImage={recallingDefaultImage}
          />
          <Bands bands={popUpDataObj.bands ? popUpDataObj.bands: ['']} />
          <Venue
            venue={popUpDataObj.venue}
          />
          <PopUpMap
            venue={popUpDataObj.venue}
            mapId={props.mainCarouselConfigObj.widgetId}
            gMapApiKey={props.mainCarouselConfigObj.gMapApiKey}
          />
        </div>: (popUpDataObj=== undefined ? 
            <span className='hearby-event-popup-not-active'>
              Event is No Longer Active
            </span>: 
              <span className='hearby-event-popup-spinner' >
                <RingLoader color={'#FF1744'} size='100' className="hearby-spinner"/>
              </span>)}

      </PopUp>
      {/* {console.log('eventGuidForPopUp in carousel.js',
       eventGuidForPopUp)} */}
      {/* {console.log('getPopUpEvents in carousel.js', popUpData)} */}
      {/* {console.log('carousel.js popUpDataObj: ', popUpDataObj)} */}
      {/* { console.log('map in carousel',
          mapObject) } */}
      {/* {console.log('props', props)} */}
    </div>

  );
}

SimpleSlider.propTypes = {
  mainCarouselConfigObj: PropTypes.object.isRequired,
};
